import React from 'react';
import PropTypes from 'prop-types';

import { Alert } from 'react-magma-dom';

class AlertPanel extends React.PureComponent {
  render () {
    return (
      <Alert
        variant={this.props.variant}
        testId="alertPanel"
        className={this.props.className}
      >
        {this.props.errMsg}
      </Alert>
    );
  }

}

AlertPanel.defaultProps = {
  variant: 'info'
};

AlertPanel.propTypes = {
  errMsg: PropTypes.string.isRequired,
  variant: PropTypes.string,
  className: PropTypes.string
};

export default AlertPanel;
